import { createSlice } from "@reduxjs/toolkit";

import TYPE from "../../constants/SearchBar";

const initalShowOnlyActiveProducts =
	localStorage.getItem("showOnlyActiveProducts") === null
		? true
		: localStorage.getItem("showOnlyActiveProducts") === "true"
			? true
			: false;

const initialState = {
	searchedPhrase: "",
	timeRange: TYPE.option1,
	accountType: [],
	startDate: new Date().toJSON(),
	endDate: new Date().toJSON(),
	predefinedDates: null,
	selectedTileID: "today",
	splitType: "month",
	lastUpdate: new Date().toJSON(),
	selectedProductIDs: [],
	excludedProductIDs: [],
	isAllProductsSelected: false,
	stateLoadedFromLocalStorage: false,
	currentPage: null,
	showOnlyActiveProducts: initalShowOnlyActiveProducts,
};

export const searchSlice = createSlice({
	name: "searchStore",
	initialState,
	reducers: {
		setAllProducts(state, action) {
			state.selectedProductIDs = [];
			state.excludedProductIDs = action.payload.excludedProductIDs;
			state.isAllProductsSelected = true;
			state.searchedPhrase = action.payload.phrase;
		},
		diselectAllProducts(state, action) {
			state.selectedProductIDs = action.payload.products;
			state.excludedProductIDs = [];
			state.isAllProductsSelected = false;
			state.searchedPhrase = action.payload.phrase;
		},
		setCurrentPage(state, action) {
			state.currentPage = action.payload;
		},
		setSelectedTileID(state, action) {
			state.selectedTileID = action.payload;
		},
		setSearchSlice(state, action) {
			state.endDate = action.payload.endDate;
			state.startDate = action.payload.startDate;
			state.splitType = action.payload.splitType;
			state.timeRange = action.payload.timeRange;
			state.predefinedDates = action.payload.predefinedDates;
			state.accountType = action.payload.accountType;
			state.selectedProductIDs = action.payload.selectedProductIDs;

			state.stateLoadedFromLocalStorage = true;
			state.searchedPhrase = action.payload.searchedPhrase;
			state.selectedTileID = action.payload.selectedTileID;

			state.currentPage = action.payload.currentPage;

			state.isAllProductsSelected = action.payload.isAllProductsSelected;
			state.excludedProductIDs = action.payload.excludedProductIDs;
		},
		setStateLoadedFromLocalStorage(state, action) {
			state.stateLoadedFromLocalStorage = action.payload;
		},
		setLastUpdate(state, action) {
			state.lastUpdate = action.payload;
		},
		resetSelectedProducts(state) {
			state.searchedPhrase = "";
			state.selectedProductIDs = [];
			state.excludedProductIDs = [];
			state.isAllProductsSelected = false;
		},
		setSearchedPhrase(state, action) {
			state.searchedPhrase = action.payload;
		},
		setSearchedAndSelectedProducts(state, action) {
			state.searchedPhrase = action.payload.phrase;
			state.selectedProductIDs = action.payload.products;
		},

		setPredefinedDate(state, action) {
			state.predefinedDates = action.payload.predefinedDates;
			state.startDate = action.payload.startDate;
			state.endDate = action.payload.endDate;
			state.splitType = action.payload.splitType;
			state.timeRange = action.payload.timeRange;
			state.selectedTileID = action.payload.selectedTileID;
		},
		setDataOnFirstLoad(state, action) {
			state.predefinedDates = action.payload.predefinedDates;
			state.startDate = action.payload.startDate;
			state.endDate = action.payload.endDate;
			state.splitType = action.payload.splitType;
			state.timeRange = action.payload.timeRange;
			state.selectedTileID = action.payload.selectedTileID;
			state.accountType = action.payload.accountType;

			state.stateLoadedFromLocalStorage =
				action.payload.stateLoadedFromLocalStorage;
			state.currentPage = action.payload.currentPage;

			state.selectedProductIDs = action.payload.selectedProductIDs;
			state.excludedProductIDs = action.payload.excludedProductIDs;
			state.isAllProductsSelected = action.payload.isAllProductsSelected;
			state.searchedPhrase = action.payload.searchedPhrase;
		},
		setAccountType(state, action) {
			state.accountType = action.payload;
		},
		setAccountTypeAndResetProducts(state, action) {
			state.accountType = action.payload;
			state.selectedProductIDs = [];
			state.excludedProductIDs = [];
			state.isAllProductsSelected = false;
			state.searchedPhrase = "";
		},
		setCustomDate(state, action) {
			state.timeRange = TYPE.custom;
			state.startDate = action.payload.startDate;
			state.endDate = action.payload.endDate;
			state.predefinedDates = action.payload.predefinedDates;
			state.splitType = action.payload.splitType;
			state.selectedTileID = action.payload.selectedTileID;
		},
		setSelectedProductsIDs(state, action) {
			state.selectedProductIDs = action.payload;
		},
		setSelectedTile(state, action) {
			state.selectedTileID = action.payload.tileID;
			state.startDate = action.payload.startDate;
			state.endDate = action.payload.endDate;
		},
		setSplitType(state, action) {
			state.splitType = action.payload;
		},
		resetSearchStore(state) {
			((state.searchedPhrase = ""),
				(state.timeRange = TYPE.option1),
				(state.accountType = []),
				(state.startDate = new Date().toJSON()),
				(state.endDate = new Date().toJSON()),
				(state.selectedProductIDs = []),
				(state.excludedProductIDs = []),
				(state.isAllProductsSelected = false),
				(state.predefinedDates = null),
				(state.selectedTileID = "today"),
				(state.splitType = "month"),
				(state.lastUpdate = new Date().toJSON()),
				(state.stateLoadedFromLocalStorage = false),
				(state.currentPage = null));
		},
		setShowOnlyActiveProducts(state, action) {
			state.showOnlyActiveProducts = action.payload;
		},
	},
});

export const searchSliceActions = searchSlice.actions;
export default searchSlice.reducer;
